
import { Bar } from "react-chartjs-2";

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@material-ui/core";

export function VisitsIndicatorSummary({ data }) {
  const labelsList = [];
  const conversionList = [];
  const visitorsList = [];
  const ticketsList = [];

  data?.map((item) => {
    labelsList.push(item?.Data);
    conversionList.push(item?.TaxaConversaoNumero);
    visitorsList.push(item?.Visitas);
    ticketsList.push(item?.Tickets);
  });

  const taxaConversao = {
    type: "line",
    label: "Taxa de Conversão",
    borderColor: "rgb(255, 0, 0)",
    borderWidth: 2,
    fill: false,
    data: conversionList,
  };

  return (
    <>
      <Card>
        <CardHeader
          subheader={
            <Grid
              container
              component={Box}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs="auto">
                <Box
                  component={Typography}
                  variant="h2"
                  marginBottom="0!important"
                >
                  <Box component="span">Indicadores - Visitas e Tickets</Box>
                </Box>
              </Grid>
            </Grid>
          }
        />
        <CardContent>
          <Grid container>
            <Grid item xs={12}>
              <Box position="relative" height="350px">
                <Bar
                  data={{
                    labels: labelsList,
                    datasets: [
                      taxaConversao,
                      {
                        type: "bar",
                        label: "Visitas",
                        backgroundColor: "rgba(223, 118, 125, 0.9)",
                        data: visitorsList,
                      },
                      {
                        type: "bar",
                        label: "Tickets",
                        backgroundColor: "rgba(28, 52, 93, 0.8)",
                        data: ticketsList,
                      },
                    ],
                  }}
                  options={{
                    plugins: {
                      title: {
                        display: true,
                        position: "top",
                      },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: {
                      mode: "index",
                      intersect: false,
                    },
                    scales: {
                      x: {
                        stacked: true,
                      },
                      y: {
                        stacked: true,
                      },
                    },
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
